import { render, staticRenderFns } from "./shipment-wig-edit-barcode.vue?vue&type=template&id=0afd2d15&scoped=true"
import script from "./shipment-wig-edit-barcode.vue?vue&type=script&lang=js"
export * from "./shipment-wig-edit-barcode.vue?vue&type=script&lang=js"
import style0 from "./shipment-wig-edit-barcode.vue?vue&type=style&index=0&id=0afd2d15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afd2d15",
  null
  
)

export default component.exports